import Azguard from "@/components/Icons/Wallets/Azguard"

const KnownAztecConnectors = [
    {
        id: 'azguard-wallet',
        icon: Azguard
    },
    {
        id: 'azguard wallet',
        icon: Azguard
    },
]

export default KnownAztecConnectors